import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { DialogService } from 'src/app/_services/dialog.service';
import { LoadingService } from 'src/app/_services/loading.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { EmailTemplateService } from '../../_leadcrmservices/email-template.service';
import { LeadService } from '../../_leadcrmservices/lead.service';

@Component({
  selector: 'app-email-template',
  templateUrl: './email-template.component.html',
  styleUrls: ['./email-template.component.css']
})
export class EmailTemplateComponent implements OnInit {

  siteList = [];

  displayedColumns: string[] = ['EmailTemplateId', 'SiteTitle', 'TemplateTtle', 'TemplateContent', 'Action'];

  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  searchKey: string;

  constructor(
    public emailTemplateService: EmailTemplateService,
    private titleService: Title,
    private dialog: MatDialog,
    private loading: LoadingService,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    public leadService: LeadService,
  ) { }

  ngOnInit() {
    this.onLoadEmailTemplates();
    this.onFetchSites();
  }


  onFetchSites() {
    var result = this.leadService.get_lead_binding_data().subscribe(data => {
      //console.log(data);
      this.siteList = data['site_list'];
      //console.log(this.siteList);
    });
  }

  onSearchClear() {
    this.searchKey = "";
    this.applyFilter();
  }

  applyFilter() {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  onLoadEmailTemplates() {
    //console.log('ok');
    this.emailTemplateService.get_email_templates().subscribe(data => {
      console.log(data);
      this.dataSource = new MatTableDataSource<any>(data['emailtemplateList']);
      this.dataSource.paginator = this.paginator;
    });
  }

  onCreate() {
      const matDialogConfig = new MatDialogConfig();
      matDialogConfig.disableClose = true;
      matDialogConfig.autoFocus = true;
      matDialogConfig.width = "35%";
      matDialogConfig.position = { top: '0px' }
      //this.dialog.open(CreateCompanyDialog, matDialogConfig);
      this.dialog.open(CreateEmailTemplateDialog, matDialogConfig).afterClosed().subscribe(res => {
        this.onLoadEmailTemplates();
      });
    }
  
    onEdit(rowData: any) {
      this.emailTemplateService.populateForm(rowData);
      const matDialogConfig = new MatDialogConfig();
      matDialogConfig.disableClose = true;
      matDialogConfig.autoFocus = true;
      matDialogConfig.width = "35%";
      matDialogConfig.position = { top: '0px' };
      this.dialog.open(CreateEmailTemplateDialog, matDialogConfig).afterClosed().subscribe(res => {
        this.onLoadEmailTemplates();
      });
    }

}








/* Create Email Template */

@Component({
  selector: 'create-email-template-dialog',
  templateUrl: 'create-email-template-dialog.html',
  styleUrls: ['./email-template.component.css']
})
export class CreateEmailTemplateDialog {

  siteList: [];

  constructor(
    private dialogRef: MatDialogRef<EmailTemplateComponent>,
    private loading: LoadingService,
    private notificationService: NotificationService,
    public emailTemplateService: EmailTemplateService,
    public leadService: LeadService,
  ) {
  }

  ngOnInit() {
    this.onFetchSites();
  }

  onFetchSites() {
    var result = this.leadService.get_lead_binding_data().subscribe(data => {
      //console.log(data);
      this.siteList = data['site_list'];
      //console.log(this.siteList);
    });
  }

  onClose() {
    this.emailTemplateService.email_template_form.reset();
    this.dialogRef.close();
  }


  onEmailTemplateFormSubmit(formData: any) {
    //console.log(formData);
    if (this.emailTemplateService.email_template_form.valid) {
      this.loading.spin$.next(true);
      if (!this.emailTemplateService.email_template_form.controls['id'].value) {
        // Insert Data
        this.emailTemplateService.insert_email_template(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.emailTemplateService.email_template_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            this.notificationService.error('Email Template Data could not be created, Try Again!');
            this.loading.spin$.next(false);
          }
        });
      }
      else {
        // Update Data
        //console.log('data updated');
        this.emailTemplateService.update_email_template(formData).subscribe(data => {
          console.log(data);
          if (data['status']) {
            this.notificationService.success(data['message']);
            this.emailTemplateService.email_template_form.reset();
            this.onClose();
            this.loading.spin$.next(false);
          }
          else {
            console.log('error');
            this.notificationService.error(data['message']);
            this.loading.spin$.next(false);
          }
        });
      }

    }
  }



}

